import React from 'react';
import PropTypes from 'prop-types';

import api from 'api';

import ErrorPage from '@lc/ui/template/ErrorPage';
import Layout from 'components/Layout';
import Booking from 'features/Booking';

const BookingIndex = ({ query, data }) => {
  if (data?.urls === undefined) return <ErrorPage statusCode={404} />;

  return (
    <Layout profileType="hoster">
      <Booking advert={data} query={query} />
    </Layout>
  );
};

BookingIndex.propTypes = {
  data: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
};

BookingIndex.getInitialProps = async ({ query, res, ...rest }) => {
  const protocol = rest.req?.socket.encrypted ? 'https:' : 'http:';
  const url = rest.req
    ? `${protocol}//${rest.req.headers.host}${rest.asPath}`
    : `www.letclinic.com/`;

  const promises = [api.getAdvertisingDetail(query.id), api.getAdvertisingRatingDetail(query.id)];

  const result = await Promise.all(promises).then(([resDetail, resRating]) => ({
    ...resDetail[0],
    'rating': resRating[0],
  }));

  if (res) {
    res.statusCode = result?.urls === undefined ? 404 : 200;
  }
  return {
    // this data is used in the _app.js
    metaTags: {
      title: result.title,
      description: result.description,
      image: result?.urls?.[0],
      url,
    },
    query,
    data: result,
  };
};

export default BookingIndex;
